module.exports = __webpack_public_path__ + "img/cooling-cycle.efb94bf6.png";